import { CAMPAIGN_ORIGIN } from '@/ts/common-types';
import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { useMemo } from 'react';

interface IUseCampaignSyncCheckParams {
    params?: {
        isCampaignSyncStatusRequired?: boolean;
    } & Record<string, any>;
}

const useCampaignSyncCheck = ({ params }: IUseCampaignSyncCheckParams) => {
    const isFeatureEnabled = useFeatureIsOn("CAMPAIGN_WIZARD_FEATURE");
    
    const { isCampaignSyncCheckRequired, showCampaignSyncStatus, showNewTag } = useMemo(() => {
        const isSyncRequired = params?.isCampaignSyncStatusRequired;
        const baseCondition = isFeatureEnabled && isSyncRequired;
        
        const isExternalCampaign = params?.data?.origin === CAMPAIGN_ORIGIN.REVINITI;
        
        //! Note[TBD]: If the new tag to be shown for all the campaign then we have to move it to some where else
        const isCreatedWithin24Hours = (() => {
            const creationDate = params?.data?.creation_date;
            
            if (!creationDate) return false;
            
            const creationTimestamp = parseInt(creationDate, 10);
            if (isNaN(creationTimestamp)) return false;
            
            // Epoch timestamps: 10 digits = seconds, 13 digits = milliseconds
            const creationTimeMs = creationDate.length === 10 
                ? creationTimestamp * 1000 
                : creationTimestamp;
            
            const currentTime = Date.now();
            const twentyFourHoursInMs = 24 * 60 * 60 * 1000;
            
            return (currentTime - creationTimeMs) <= twentyFourHoursInMs;
        })();
        
        return {
            isCampaignSyncCheckRequired: baseCondition && isExternalCampaign,
            showCampaignSyncStatus: baseCondition && !!params?.data?.sync_state,
            showNewTag: isFeatureEnabled && isCreatedWithin24Hours
        };
    }, [isFeatureEnabled, params?.isCampaignSyncStatusRequired, params?.data?.origin, params?.data?.sync_state, params?.data?.creation_date]);

    return { isCampaignSyncCheckRequired, showCampaignSyncStatus, showNewTag };
};

export default useCampaignSyncCheck;
